const removeQueryStringFromLocation = () => {
  history.replaceState(null, "", `${window.location.origin}${window.location.pathname}`)
}

export default removeQueryStringFromLocation
